export function commonHelper() {

    const stripHtml = (html: string) => {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }

    const stripTags = (html: string) => {
      let regex = /(<([^>]+)>)/ig;
      return html.replace(regex, "");
    }

    return {
      stripHtml,
      stripTags
    };
  }
  
  export * from './commonHelper';
  export default commonHelper;
  